export function getKeysData(data = {}, {exclude = [], order = []} = {}){
    let keys = Object.keys(data);

    if(exclude.length){
        const set = new Set(exclude);
        keys = keys.filter(k => !set.has(k));
    }

    if(order.length){
        const pos = new Map(order.map((k, i) => [k, i]))
        keys.sort((a, b) => {
            const pa = pos.has(a) ? pos.has(a) : Number.MAX_SAFE_INTEGER;
            const pb = pos.has(b) ? pos.has(b) : Number.MAX_SAFE_INTEGER;
            return pa - pb || a.localeCompare(b);
        });
    }
    return keys;
}

export function formatKeys(keys){
    keys = keys.map(k => toUpperCamelCase(k));
    keys[0] = 'ID';

    return keys;
}

function toUpperCamelCase(text) {
  return text.replace(/^\w/, c => c.toUpperCase());
}